import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import {trigger, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'dp-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    animations: [    trigger('fade', [ 
         transition('void => *', [
          style({ opacity: 0 }), 
          animate(2000, style({opacity: 1}))
        ]) 
      ])]
})
export class LoadingComponent implements OnInit {
    @ViewChild('element') public element: ElementRef;
    @Input() public text: string;

    public ngOnInit() {
         //this.element.nativeElement.scrollIntoView();
    }
}
